import { useEffect } from "react";

function App() {
  useEffect(() => {
    // Single-file HTML deliverable lives in /public/landing.html
    window.location.replace("/landing.html");
  }, []);
  return null;
}

export default App;
